module.exports = __webpack_public_path__ + "img/premium-currency-section-introduction.14c6fb10.svg";